import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { AssetName, Text, NotificationLayoutItemProjectName, UserName } from '../../../gql/generated/LayoutItems';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type TransferBatchCompletedHeader_NotificationGroupAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupAccessRequestApproved' };

export type TransferBatchCompletedHeader_NotificationGroupAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupAccessRequestDenied' };

export type TransferBatchCompletedHeader_NotificationGroupAccessRequestSubmitted_Fragment = { __typename?: 'NotificationGroupAccessRequestSubmitted' };

export type TransferBatchCompletedHeader_NotificationGroupAssetAssignedToYou_Fragment = { __typename?: 'NotificationGroupAssetAssignedToYou' };

export type TransferBatchCompletedHeader_NotificationGroupAssetStatusChanged_Fragment = { __typename?: 'NotificationGroupAssetStatusChanged' };

export type TransferBatchCompletedHeader_NotificationGroupCommentCreated_Fragment = { __typename?: 'NotificationGroupCommentCreated' };

export type TransferBatchCompletedHeader_NotificationGroupCommentCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupCommentCreatedShareAccess' };

export type TransferBatchCompletedHeader_NotificationGroupFileUploaded_Fragment = { __typename?: 'NotificationGroupFileUploaded' };

export type TransferBatchCompletedHeader_NotificationGroupReplyCreated_Fragment = { __typename?: 'NotificationGroupReplyCreated' };

export type TransferBatchCompletedHeader_NotificationGroupReplyCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupReplyCreatedShareAccess' };

export type TransferBatchCompletedHeader_NotificationGroupRequesterAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestApproved' };

export type TransferBatchCompletedHeader_NotificationGroupRequesterAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestDenied' };

export type TransferBatchCompletedHeader_NotificationGroupTranscriptCompletedSelf_Fragment = { __typename?: 'NotificationGroupTranscriptCompletedSelf' };

export type TransferBatchCompletedHeader_NotificationGroupTransferBatchCompleted_Fragment = { __typename?: 'NotificationGroupTransferBatchCompleted', content: { __typename?: 'NotificationGroupContent', layout: { __typename?: 'NotificationLayout', header: Array<{ __typename?: 'NotificationLayoutItemAssetName' } | { __typename?: 'NotificationLayoutItemChip' } | { __typename?: 'NotificationLayoutItemProjectName' } | { __typename?: 'NotificationLayoutItemSection' } | { __typename?: 'NotificationLayoutItemShareName' } | { __typename?: 'NotificationLayoutItemText', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } } | { __typename?: 'NotificationLayoutItemTimestamp' } | { __typename?: 'NotificationLayoutItemUserName', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } }> } } };

export type TransferBatchCompletedHeader_NotificationGroupTransferBatchCompletedSelf_Fragment = { __typename?: 'NotificationGroupTransferBatchCompletedSelf' };

export type TransferBatchCompletedHeader_NotificationGroupUserMentioned_Fragment = { __typename?: 'NotificationGroupUserMentioned' };

export type TransferBatchCompletedHeader_NotificationGroupUserMentionedShareAccess_Fragment = { __typename?: 'NotificationGroupUserMentionedShareAccess' };

export type TransferBatchCompletedHeaderFragment = TransferBatchCompletedHeader_NotificationGroupAccessRequestApproved_Fragment | TransferBatchCompletedHeader_NotificationGroupAccessRequestDenied_Fragment | TransferBatchCompletedHeader_NotificationGroupAccessRequestSubmitted_Fragment | TransferBatchCompletedHeader_NotificationGroupAssetAssignedToYou_Fragment | TransferBatchCompletedHeader_NotificationGroupAssetStatusChanged_Fragment | TransferBatchCompletedHeader_NotificationGroupCommentCreated_Fragment | TransferBatchCompletedHeader_NotificationGroupCommentCreatedShareAccess_Fragment | TransferBatchCompletedHeader_NotificationGroupFileUploaded_Fragment | TransferBatchCompletedHeader_NotificationGroupReplyCreated_Fragment | TransferBatchCompletedHeader_NotificationGroupReplyCreatedShareAccess_Fragment | TransferBatchCompletedHeader_NotificationGroupRequesterAccessRequestApproved_Fragment | TransferBatchCompletedHeader_NotificationGroupRequesterAccessRequestDenied_Fragment | TransferBatchCompletedHeader_NotificationGroupTranscriptCompletedSelf_Fragment | TransferBatchCompletedHeader_NotificationGroupTransferBatchCompleted_Fragment | TransferBatchCompletedHeader_NotificationGroupTransferBatchCompletedSelf_Fragment | TransferBatchCompletedHeader_NotificationGroupUserMentioned_Fragment | TransferBatchCompletedHeader_NotificationGroupUserMentionedShareAccess_Fragment;

export type TransferBatchCompletedHeaderContentFragment = { __typename?: 'NotificationLayout', header: Array<{ __typename?: 'NotificationLayoutItemAssetName' } | { __typename?: 'NotificationLayoutItemChip' } | { __typename?: 'NotificationLayoutItemProjectName' } | { __typename?: 'NotificationLayoutItemSection' } | { __typename?: 'NotificationLayoutItemShareName' } | { __typename?: 'NotificationLayoutItemText', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } } | { __typename?: 'NotificationLayoutItemTimestamp' } | { __typename?: 'NotificationLayoutItemUserName', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } }> };

export const TransferBatchCompletedHeaderContent = /*#__PURE__*/ gql`
    fragment TransferBatchCompletedHeaderContent on NotificationLayout {
  header {
    ...UserName
    ...Text
  }
}
    ${UserName}
${Text}` as unknown as DocumentNode<TransferBatchCompletedHeaderContentFragment, unknown>;
export const TransferBatchCompletedHeader = /*#__PURE__*/ gql`
    fragment TransferBatchCompletedHeader on NotificationGroup {
  ... on NotificationGroupTransferBatchCompleted {
    content {
      layout {
        ...TransferBatchCompletedHeaderContent
      }
    }
  }
}
    ${TransferBatchCompletedHeaderContent}` as unknown as DocumentNode<TransferBatchCompletedHeaderFragment, unknown>;

        

        
export const useTransferBatchCompletedHeaderFragment = (
  input: string | Omit<UseFragmentOptions<TransferBatchCompletedHeaderFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationGroup' } };
    return input;
  })();

  return useFragment<TransferBatchCompletedHeaderFragment>({
    fragment: TransferBatchCompletedHeader,
    fragmentName: 'TransferBatchCompletedHeader',
    ...options,
  });
};
  
        
        

        
export const useTransferBatchCompletedHeaderContentFragment = (
  input: string | Omit<UseFragmentOptions<TransferBatchCompletedHeaderContentFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationLayout' } };
    return input;
  })();

  return useFragment<TransferBatchCompletedHeaderContentFragment>({
    fragment: TransferBatchCompletedHeaderContent,
    fragmentName: 'TransferBatchCompletedHeaderContent',
    ...options,
  });
};
  
        